import { render } from "./ForgotByEmail.vue?vue&type=template&id=55675682&scoped=true"
import script from "./ForgotByEmail.vue?vue&type=script&lang=js"
export * from "./ForgotByEmail.vue?vue&type=script&lang=js"

import "./ForgotByEmail.vue?vue&type=style&index=0&id=55675682&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55675682"]])

export default __exports__